import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ComparationItems } from "../utils";

export function PdfComparation(props: { dataList: ComparationItems[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "COMPARATION", key: "comparation", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.mr_comparation_code ?? "-",
    comparation: item.mr_comparation_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Comparation" />;
}
